import { drawing } from '@progress/kendo-drawing';
import { VisualBase } from './VisualBase.js';
import { MarkerPathMixin } from './MarkerPathMixin.js';
import { createSegment } from './utils.js';
import '../math/Graph.js';
import { Point } from '../math/Shapes.js';

class Line extends VisualBase {
    constructor(options) {
        super(options);
        this._capMap = MarkerPathMixin._capMap;
        this.container = new drawing.Group();
        this._getPath = MarkerPathMixin._getPath.bind(this);
        this._normalizeMarkerOptions = MarkerPathMixin._normalizeMarkerOptions.bind(this);
        this._removeMarker = MarkerPathMixin._removeMarker.bind(this);
        this._createMarkers = MarkerPathMixin._createMarkers.bind(this);
        this._createMarker = MarkerPathMixin._createMarker.bind(this);
        this._positionMarker = MarkerPathMixin._positionMarker.bind(this);
        this._redrawMarker = MarkerPathMixin._redrawMarker.bind(this);
        this._redrawMarkers = MarkerPathMixin._redrawMarkers.bind(this);
        this._initPath();
        this._createMarkers();
    }
    drawingContainer() {
        return this.container;
    }
    redraw(options) {
        if (options) {
            options = options || {};
            const from = options.from;
            const to = options.to;
            if (from) {
                this.options.from = from;
            }
            if (to) {
                this.options.to = to;
            }
            if (from || to) {
                this._drawPath();
                this._redrawMarkers(true, options);
            }
            else {
                this._redrawMarkers(false, options);
            }
            super.redraw(options);
        }
    }
    _initPath() {
        const options = this.options;
        const drawingElement = this.drawingElement = new drawing.Path({
            stroke: options.stroke
        });
        this._fill();
        this._drawPath();
        this.container.append(drawingElement);
    }
    _drawPath() {
        const options = this.options;
        const drawingElement = this.drawingElement;
        const from = options.from || new Point();
        const to = options.to || new Point();
        drawingElement.segments.elements([
            createSegment(from.x, from.y),
            createSegment(to.x, to.y)
        ]);
    }
}

export { Line };
